import React, { PropsWithChildren } from 'react';
import { FormField as FormFieldNew } from './FormField';
import { convertOldFormFieldChildren, convertOldFormFieldProps } from './converter.old';
import type { OldFormFieldProps } from './converter.old';

export type FormFieldProps = OldFormFieldProps;

export const FormField = (props: PropsWithChildren<FormFieldProps>) => {
  const convertedProps = convertOldFormFieldProps(props);

  return (
    <FormFieldNew {...convertedProps}>
      {convertOldFormFieldChildren(props.children, convertedProps.status)}
    </FormFieldNew>
  );
};
